import moment from "moment";
import {ReportDownloadModel} from "@/model/ReportDownloadModel";
import {FileDownload} from "@/scripts/Common/FileDownload";

export class ReportDownload{

    public static Create(model:ReportDownloadModel){
        let fileName = this.BuildFileName(model);
        FileDownload.Create(model.Data, fileName);
    }
    
    private static BuildFileName(model:ReportDownloadModel){
        return !!model.EndDate
            ? `${model.Filename}_${this.formatDate(model.StartDate, model.DateFormat)}_${this.formatDate(model.EndDate, model.DateFormat)}.csv`
            : `${model.Filename}_${this.formatDate(model.StartDate, model.DateFormat)}.csv`;
    }
    
    private static formatDate(date:string, format:string){
        return moment(date).format(format);
    }
}